// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const PUT_SELECTED_COUNTRY_DATA = 'PUT_SELECTED_COUNTRY_DATA';
export const PUT_SELECTED_COUNTRY_DATA_SUCCESS = 'PUT_SELECTED_COUNTRY_DATA_SUCCESS';
export const RESET_SELECTED_COUNTRY_DATA = 'RESET_SELECTED_COUNTRY_DATA';

export const {
    putSelectedCountryData,
    putSelectedCountryDataSuccess,
    resetSelectedCountryData,
} = createActions(PUT_SELECTED_COUNTRY_DATA, PUT_SELECTED_COUNTRY_DATA_SUCCESS, RESET_SELECTED_COUNTRY_DATA);
